// WhatsApp helpers for Bendito Tattoo
export const WA_NUMBER = "5219844985289";

export const waLink = (message) => {
  const base = `https://wa.me/${WA_NUMBER}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
};

export const PRESET = {
  generalEn: "Hi! I'm interested in booking at Bendito Tattoo.",
  generalEs: "¡Hola! Me interesa agendar en Bendito Tattoo.",
  eeme: "Hi! I'd like to book a tattoo session with EEME.",
  may: "Hi! I'd like to book a tattoo session with May.",
  tyson: "Hi! I'd like to book a piercing/mod session with Tyson.",
  alvaro: "Hi! I'd like to book a tattoo session with Alvaro.",
  avelino: "Hi! I'd like to book a tattoo session with Avelino.",
  ezzer: "Hi! I'd like to book a tattoo session with Ez'zer.",
  portfolioInquiryEn: "Hi! I saw this piece on your website and I'd love something similar.",
  portfolioInquiryEs: "¡Hola! Vi esta pieza en su sitio y me encantaría algo similar.",
};

export const buildQuoteMessage = (form, lang, backendUrl) => {
  const L = lang === "es";
  const lines = [];
  lines.push(L ? "¡Hola Bendito Tattoo!" : "Hi Bendito Tattoo!");
  lines.push("");
  lines.push(L ? "Quisiera una cotización:" : "I'd like a quote:");
  lines.push("");
  if (form.service_type) {
    const map = L
      ? { tattoo: "Tatuaje", piercing: "Piercing", body_mod: "Body Mod" }
      : { tattoo: "Tattoo", piercing: "Piercing", body_mod: "Body Mod" };
    lines.push(`• ${L ? "Servicio" : "Service"}: ${map[form.service_type] || form.service_type}`);
  }
  if (form.style) lines.push(`• ${L ? "Estilo" : "Style"}: ${form.style}`);
  if (form.size) lines.push(`• ${L ? "Tamaño" : "Size"}: ${form.size}`);
  if (form.placement) lines.push(`• ${L ? "Ubicación" : "Placement"}: ${form.placement}`);
  if (form.preferred_artist)
    lines.push(`• ${L ? "Artista" : "Artist"}: ${form.preferred_artist}`);
  if (form.when) {
    let w = form.when;
    if (form.when === "arriving" && form.when_date) w = `${L ? "Llego el" : "Arriving"} ${form.when_date}`;
    else if (form.when === "now") w = L ? "Ya estoy en Playa" : "Already in Playa";
    else if (form.when === "exploring") w = L ? "Solo explorando" : "Just exploring";
    lines.push(`• ${L ? "Cuándo" : "When"}: ${w}`);
  }
  if (form.name) lines.push(`• ${L ? "Nombre" : "Name"}: ${form.name}`);
  lines.push("");
  lines.push(L ? "Envía tu referencia/diseño por WhatsApp" : "Send your reference/design via WhatsApp");
  return lines.join("\n");
};
